import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import VersiWAP from "../../../MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo";
import { set4dGameSubChildtype, setCommonConfig } from "../../../../../redux/actions";
import MarketClose from "../../MarketClose";
import GameClosedPopup from "../../GameClosedPopup";
import { withTranslation } from "react-i18next";
import BalakBalikVersiWap from "./BalakBalikVersiWap";
import BalakBalikFullVersiWap from "./BalakBalikFullVersiWap";

const FourDThreeDTwoD = (props) => {
  const dispatch = useDispatch();

  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const marketStatus = useSelector((state) => state.CommonConfig.discount)
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const subGameOnOffStatus = useSelector((state) => state.CommonConfig.subGameOnOffStatus);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const user_profile = useSelector(state => state.UserProfile);
  const clickTab = useSelector((state) => state.CommonConfig.clickTab);

  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: tabIndex == "1" ? "DISCOUNT" : tabIndex == "2" ? "FULLBET" : "" }));
  };

  useEffect(() => {
    setActiveTab(1)
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
  }, [gameId])

  useEffect(() => {
    setActiveTab(1);
    dispatch(setCommonConfig({ key: 'gameType', value: 'bolak-balik' }));
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
    dispatch(setCommonConfig({ key: 'clickTab', value: 0 }));
  }, [clickTab])

 
 
 
return (
    <>
      <div className="inner_nav-tabwrapper">
        {marketStatus.fullbetStatus == 0 && marketStatus.prize123Status == 0 ? '' : 
        
          <div
            className={`inner_tab ${activeTab === 1 ? "active" : ""}`}
            onClick={() => handleTabClick(1)}
          >
            DISCOUNT
          </div>
        }
        {marketStatus.fullbetStatus == 0 ? '' : 

        
          <div
            className={`inner_tab ${activeTab === 2 ? "active" : ""}`}
            onClick={() => handleTabClick(2)}
          >
            FULLBET
          </div>
        }
      </div>
      {
        device === "Mobile" ? (
          <>
            <VersiWAP />
            {/* <Rules /> */}
            {app_type === "wap" ?
              <div className='rules_container'>
                <div>
                  <p>{props.t('guess_exact_number')}</p>
                  <p>Format Taruhan: nomor1*nomor2*nomor3#bet+
                    nomor1*nomor2#bet</p>
                  <p>Contoh Penulisan: 123*1234*12#5+11*  222*333#1+33*777#2</p>
                </div>
                <div className='rules_conversion'>
                  <p>Konversi <br /> 1 = 1,000</p>
                </div>
              </div>
              : ""}
          </>
        ) : null
      }

      <div className="tabcontent-wrapper">
        {activeTab === 1 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <BalakBalikVersiWap /> : <BalakBalikVersiWap />))}</div>}
        {activeTab === 2 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <BalakBalikFullVersiWap /> : <BalakBalikFullVersiWap />))}</div>}
      </div>
    </>
  );
};

export default withTranslation()(FourDThreeDTwoD);